import {CSSProperties, useState} from "react";
import {Button, Form, Modal} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {LoginAction, RequestPassChange} from "./AuthActions";
import { useTranslation } from "react-i18next";
interface Props {
  show: boolean;
  onHide: () => void;
  showRegister: () => void;
}
const Login = ({show, onHide, showRegister}: Props) => {
  const {t} = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({email: "", password: ""});
  const dispatch = useAppDispatch();
  const handleShowRegister = () => {
    closeForm();
    showRegister();
  };
  const closeForm = () => {
    setEmail("");
    setPassword("");
    setErrors({email: "", password: ""});
    onHide();
  };
  const validateForm = () => {
    let valid = true;
    let errors = {email: "", password: ""};

    if (!email) {
      valid = false;
      errors.email = t('enter_email');
    }

    if (!password) {
      valid = false;
      errors.password = t('enter_password');
    }

    setErrors(errors);
    return valid;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (validateForm()) {
      dispatch(LoginAction(email, password)).then((response: boolean) => {
        if(response){
          closeForm();
        }
      });
    }
  };

  const handleChangePassword = () => {
    if (!email) {
      errors.email = t('enter_email');
      return;
    }
    dispatch(RequestPassChange(email));
    closeForm();
  };
  const handleEnter = (e :any) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <Modal size="mini" centered closeIcon open={show} onClose={closeForm}>
      <Modal.Header style={loginstyles.header}>{t('login')}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={handleSubmit}>
          <Form.Field>
            <label>{t('email')}</label>
            <Form.Input type="email" placeholder={t('enter_email')} value={email} onChange={(e) => setEmail(e.target.value)} error={errors.email ? {content: errors.email, pointing: "below"} : false} />
          </Form.Field>
          <Form.Field>
            <label>{t('password')}</label>
            <Form.Input type="password" placeholder={t('enter_password')} value={password} onKeyPress={handleEnter} onChange={(e) => setPassword(e.target.value)} error={errors.password ? {content: errors.password, pointing: "below"} : false} />
          </Form.Field>
        </Form>
        <Button size="mini" basic style={{...loginstyles.button, marginTop: 5}} onClick={handleChangePassword}>
            {t('forgot_pass')}
          </Button>
      </Modal.Content>
      <Modal.Actions>
        <Form.Button style={loginstyles.button} primary type="submit" onClick={handleSubmit}>
        {t('login_btn')}
        </Form.Button>
        <div style={loginstyles.registerButton as CSSProperties} onClick={handleShowRegister}>
        {t('dont_have_acc')}
          <Form.Button style={{marginLeft: 5}} compact size="mini">
          {t('register_btn')}
          </Form.Button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

const loginstyles = {
  header: {
    textAlign: "center",
  },
  button: {
    width: "100%",
  },
  registerButton: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    textAlign: "center",
    width: "100%",
    marginTop: 10,
    cursor: "pointer",
  },
};
export default Login;
